import { render } from "./about-digital-sigature.vue?vue&type=template&id=d99aa7b6"
import script from "./about-digital-sigature.vue?vue&type=script&lang=js"
export * from "./about-digital-sigature.vue?vue&type=script&lang=js"

import "./about-digital-sigature.vue?vue&type=style&index=0&id=d99aa7b6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__